import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { Typography, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { fetchInsureeByName } from "../action";
import { useTranslation } from "react-i18next";
import { cleanSelectedInsuree, cleanVerificationCode } from "../store/actions/exampleAction";

const InsureePicker = ({
  value,
  label,
  onChange,
  id,
  type,
  error,
  placeholder,
  insureeNo,
  input,
  meta,
  name,
  requiredCamuNumber,
  ...props
}) => {
  const { t } = useTranslation();

  const SignInSuccess = useSelector((state) => state);
  const [insureeData, setInsureeData] = useState();
  const [chfId, setChfId] = useState("");
  const [otherNames, setOtherNames] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    setInsureeData(SignInSuccess?.profileReducer?.insureeByIdResponseData);
  }, [SignInSuccess]);
  useEffect(() => {
    if (insureeNo?.insureeNo) {
      if (requiredCamuNumber) {
        dispatch(fetchInsureeByName("", insureeNo?.insureeNo));
      } else {
        dispatch(fetchInsureeByName(insureeNo?.insureeNo));
      }
    }
  }, [insureeNo]);

  useEffect(() => {
    dispatch(cleanSelectedInsuree())
  }, [])

  useEffect(() => {
    if (insureeData) {
      setChfId(insureeData[0]?.chfId);
      setOtherNames(insureeData[0]?.otherNames);
    }
  }, [insureeData]);
  const Content = styled(Typography)`
  margin-bottom: 0.3rem;
`;
  return (
    <>
      <Content>
        <Typography color="#666666">{label}</Typography>
      </Content>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { width: "100%" },
        }}
        noValidate
        autoComplete="off"
      >
        <Grid style={{ display: "flex" }}>
          <TextField
            label={""}
            id={id}
            name={name}
            variant="outlined"
            value={!!value ? chfId : ""}
            type={type}
            onChange={onChange}
            fullWidth
            size="small"
            placeholder={placeholder}
            error={meta && meta.touched && meta.error && error}
            // helperText={error}
            autocomplete="off"
            aria-autocomplete="none"
            {...input}
            {...props}
          />
          <TextField
            style={{ marginLeft: "10px" }}
            variant="outlined"
            label={t("Name")}
            value={insureeNo?.insureeNo ? otherNames : ""}
            disabled={true}
            fullWidth
            size="small"
            autocomplete="off"
            aria-autocomplete="none"
          />
        </Grid>
      </Box>
    </>
  );
};

export default InsureePicker;
